<template>
  <CElementCover :opacity="0.75">
    <div class="text-dark p-3 text-center">
      <img :src="imageName" alt="Spinner" :height="size" :width="size" />
      <h4 class="mt-2">{{ message }}</h4>
    </div>
  </CElementCover>
</template>
<script>
  export default {
    name: "LoadingCover",
    data() {
      return {
        imageName: ""
      }
    },
    props: {
      spinner: {
        type: String,
        default: "grid-bullets"
      },
      size: {
        type: Number,
        default: 24
      },
      message: {
        type: String,
        default: "Cargando..."
      }
    },
    methods: {
      getUrlImage(str) {
        const images = require.context("@/assets/images", false, /\.svg$/)

        return images(`./${str}`)
      }
    },
    mounted() {
      if (this.spinner === "bullets") {
        this.imageName = this.getUrlImage("bullets-shuffle.svg");
      } else if (this.spinner === "grid-bullets") {
        this.imageName = this.getUrlImage("grid-bullets.svg");
      } else if (this.spinner === "blocks") {
        this.imageName = this.getUrlImage("blocks-shuffle.svg");
      } else if (this.spinner === "clock") {
        this.imageName = this.getUrlImage("clock.svg");
      } else if (this.spinner === "ring") {
        this.imageName = this.getUrlImage("ring-infinity.svg")
      } else if (this.spinner === "circles") {
        this.imageName = this.getUrlImage("circles.svg");
      } else if (this.spinner === "linebar") {
        this.imageName = this.getUrlImage("line-bar.svg");
      } else if (this.spinner === "blocksbar") {
        this.imageName = this.getUrlImage("blocks-bar.svg");
      } else if (this.spinner === "dotsbar") {
        this.imageName = this.getUrlImage("dots-bar.svg");
      }
    }
  }
</script>
